import React, { useState, useEffect, useLayoutEffect } from "react";
import Footer from "../footer";
import Navbar from "../navbar";
import GoogleFloater from "../googleFloater";
import TelegramFooter from "../telegramFooter";
import Newherotop from "../dashboard/Hero/Newhero/Newhero-topbar";
import Newmobilenav from "../dashboard/Hero/Newhero/Newmobilenav";
import Prebar from "../dashboard/Hero/Newhero/mobileprebar";
import styles from "./layout.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getBanner,
  getGoogleRatings,
  getPromotionData,
} from "../../redux/action";
import { useLocation } from "react-router";
import { showPromoOnThisPage } from "../../utils/constants";
import Promotion from "../modals/Promotion/Promotion";
import { AuthModal } from "../modals";
import SignUp from "../auth/signUp/signUp";
import MentorSignUp from "../auth/signUp/mentorSignUp";
import Login from "../auth/login";
import Cookies from "js-cookie";

const PageLayout = ({
  children,
  hasFooter = true,
  hasNavbar = true,
  hasCourseNav = false,
  mentorPage = false,
  hideAuthBar = false,
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    window.history.scrollRestoration = "manual";
  }, []);

  const dispatch = useDispatch();
  const location = useLocation();
  const pagePath = location.pathname;
  const [isPromoPopUp, setPromoPopUp] = useState(false);
  const isCheckoutPage = /^\/course-details\/[^/]+\/checkout$/.test(
    location.pathname
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const schedule =
      "requestIdleCallback" in window
        ? window.requestIdleCallback(() => {
            dispatch(getPromotionData());
            dispatch(getGoogleRatings());
          })
        : window.setTimeout(() => {
            dispatch(getPromotionData());
            dispatch(getGoogleRatings());
          }, 1500);

    return () => {
      if ("cancelIdleCallback" in window) {
        window.cancelIdleCallback(schedule);
      } else {
        window.clearTimeout(schedule);
      }
    };
  }, [dispatch]);

  const {
    promotionData,
    googleRatings,
    showModal,
    showSignUpModal,
    showMentorSignUpModal,
  } = useSelector((state) => state);
  const currentTime = Date.now();
  const delayTimeInDays = 7;
  const delayTime = delayTimeInDays * 24 * 60 * 60 * 1000; // delay time in milliseconds
  const lastShownPromoTimestamp = Cookies.get("lastShownPromoTimestamp");

  useEffect(() => {
    // Check if lastShownTimestamp exists and if it does, check if delayTime has not passed since the last display
    if (
      lastShownPromoTimestamp &&
      lastShownPromoTimestamp + delayTime > currentTime
    )
      return;

    if (
      promotionData?.showPopup &&
      showPromoOnThisPage(pagePath, promotionData)
    ) {
      // Show Promo after given time in seconds
      const timeId = setTimeout(
        () => setPromoPopUp(true),
        promotionData.showAfterTimeInSeconds * 1000
      );

      // Update lastShownTimestamp to the current time and store it in a cookie
      Cookies.set("lastShownPromoTimestamp", currentTime, {
        expires: delayTimeInDays,
      });

      return () => clearTimeout(timeId);
    }
  }, [promotionData]);

  function onClose() {
    setPromoPopUp(false);
  }

  useEffect(() => {
    const timerId = window.setTimeout(() => {
      dispatch(getBanner());
    }, 1200);

    return () => window.clearTimeout(timerId);
  }, [dispatch]);

  // showBanner indicates whether the banner shows on the page or not
  const [showBanner, setShowBanner] = useState(false);

  const { bannerData } = useSelector((state) => state);

  useLayoutEffect(() => {
    if (bannerData?.showBanner && showPromoOnThisPage(pagePath, bannerData)) {
      setShowBanner(true);
    }
  }, [bannerData]);

  const [navbarHeight, setHeight] = useState(0);
  const sectionStyles = {
    // position: "relative",
    // this will ensure navbar doesn't overlap content
    // top: `${navbarHeight - 120}px`,
  };

  return (
    <section className="bg-white">
      {hasNavbar && (
        <Navbar
          showBanner={showBanner}
          setShowBanner={setShowBanner}
          bannerData={bannerData}
          setHeight={setHeight}
          mentorPage={mentorPage}
          hideAuthBar={hideAuthBar}
        />
      )}
      {hasCourseNav && (
        <>
          {/* Desktop course navigation - Fixed */}
          <div className="hidden md:block fixed top-0 left-0 right-0 z-50">
            <Newherotop />
          </div>
          {/* Mobile course navigation - Fixed */}
          <div className="block md:hidden fixed top-0 left-0 right-0 z-50">
            <Newmobilenav />
            <Prebar />
          </div>
        </>
      )}
      {isPromoPopUp && (
        <Promotion onClose={onClose} promoData={promotionData} />
      )}
      <section style={sectionStyles}>
        {/* Add padding-top when course nav is fixed: mobile nav (72px) + prebar (~48px) = ~120px, desktop nav = 92px */}
        <div
          className={`${styles["page_body"]} ${
            hasCourseNav ? "pt-[120px] md:pt-[92px]" : ""
          }`}
        >
          {/* Only show GoogleFloater if we're not on the dashboard page */}
          {googleRatings?.rating &&
            !location.pathname.includes("/dashboard") && (
              <GoogleFloater ratings={googleRatings.rating.toFixed(1)} />
            )}
          {showModal && (
            <AuthModal>
              <Login />
            </AuthModal>
          )}
          {showSignUpModal && (
            <AuthModal isSignup>
              <SignUp />
            </AuthModal>
          )}
          {showMentorSignUpModal && (
            <AuthModal isSignup>
              <MentorSignUp />
            </AuthModal>
          )}
          {children}
        </div>
        {hasFooter && !(isMobile && isCheckoutPage) && (
          <>
            <TelegramFooter />
            <Footer />
          </>
        )}
      </section>
    </section>
  );
};

export default PageLayout;
